import { useState } from "react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/ui/modal";

const AddSaasPaymentModal = ({ shop, onAdd, onClose }) => {
  const [formData, setFormData] = useState({
    plan_type: "Monthly",
    business_owner: shop?.owners?.[0]?.owner_name || "",
    payment_date: "",
    amount: "",
    method: "Mobile",
    status: "PAID",
  });

  const handleSubmit = () => {
    if (!formData.payment_date || !formData.amount) {
      alert("Please fill all required fields");
      return;
    }
    onAdd({
      id: Date.now(),
      ref: `SUB-${new Date().getFullYear()}-${String(Date.now()).slice(-3)}`,
      ...formData,
      shop_name: shop?.name || "",
      amount: parseFloat(formData.amount),
      expire_date: new Date(new Date(formData.payment_date).setMonth(new Date(formData.payment_date).getMonth() + 1)).toISOString().split("T")[0],
      days_remaining: 30,
    });
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Add SAAS Payment"
      footer={
        <div className="flex flex-col-reverse sm:flex-row justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} className="bg-blue-800 hover:bg-blue-900 text-white">
            <FontAwesomeIcon icon={faSave} className="mr-2" /> Save Payment
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="text-sm font-semibold">Plan Type</label>
            <select className="w-full border rounded p-2" value={formData.plan_type} onChange={(e) => setFormData({...formData, plan_type: e.target.value})}>
              <option>Monthly</option>
              <option>Quarterly</option>
              <option>Semi-Annual</option>
              <option>Annual</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold">Business Owner</label>
            <Input value={formData.business_owner} onChange={(e) => setFormData({...formData, business_owner: e.target.value})} placeholder="Owner name" />
          </div>
        </div>
        <div>
          <label className="text-sm font-semibold">Payment Date *</label>
          <Input type="date" value={formData.payment_date} onChange={(e) => setFormData({...formData, payment_date: e.target.value})} />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="text-sm font-semibold">Amount (TZS) *</label>
            <Input type="number" min="0" value={formData.amount} onChange={(e) => setFormData({...formData, amount: e.target.value})} placeholder="0" />
          </div>
          <div>
            <label className="text-sm font-semibold">Method</label>
            <select className="w-full border rounded p-2" value={formData.method} onChange={(e) => setFormData({...formData, method: e.target.value})}>
              <option>Mobile</option>
              <option>Cash</option>
              <option>Bank Transfer</option>
              <option>Credit</option>
            </select>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddSaasPaymentModal;